// App.tsx
import { Routes, Route } from 'react-router-dom';
import AiApp from './AiApp';
import AiQuestionChatApp from './AiQuestionChatApp';

export default function RouteApp() {
  return (
    <Routes>
      <Route path="/apps/chat" element={<AiApp />} />
      <Route path="/apps/chat/:sessionId" element={<AiApp />} />
      <Route path="/apps/chat/q/:qtype/:qid" element={<AiQuestionChatApp />} />
    </Routes>
  );
}